import { React, useState, useRef } from "react";
import githubicon from "./images/github.svg";
import mailicon from "./images/envelope-regular.svg";
import emailjs from "emailjs-com";
import { useContext } from "react";
import { defaultLang } from "./LanguageContext";
export default function Contact() {
  const { lang } = useContext(defaultLang);
  const [result, setResult] = useState(false);

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xyft30p",
        "template_1scnbbc",
        form.current,
        "rkJ-667mJp5-zcarz"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    setResult(true);
  };

  if (result) {
    console.log("success");
  }
  return (
    <>
      <section>
        <h1 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-5xl pb-6 mt-28 font-bold tracking-wider '>
          {lang === "Eng" ? "Contact me" : "Contattami"}
        </h1>
        <div className='w-[30px] h-[8px] bg-[#9499ff] rounded-[10px] mx-auto'></div>
        <h2 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-xl mt-5 font-semibold tracking-wider'>
          {lang === "Eng" ? "Let's have a chat" : "Facciamo due chiacchiere"}
        </h2>
        <div className=' flex justify-center'>
          <div className='   mx-auto  top-[0px] p-8  w-[500px] md:w-[756px] h-[fit-content]'>
            <div className='relative  py-20 rounded-lg shadow bg-[#242424] dark:bg-white border-[2px] border-[#6368ca] '>
              <div className='mx-5'>
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  className=' flex gap-2 flex-col items-center justify-center'
                  action=''>
                  <div className=''>
                    <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  tracking-wider text-xl font-semibold py-2'>
                      {lang === "Eng" ? "Name" : "Nome"}
                    </h2>
                    <input
                      className='bg-[#1E1E1E] dark:bg-[#E3E3E3] py-3 px-5 w-[20rem] md:w-[30rem] text-left text-[#E3E3E3] dark:text-[#1E1E1E]  outline-none rounded-sm focus:outline-[#9499ff]'
                      type='text'
                      name='fullName'
                      required
                      placeholder={
                        lang === "Eng"
                          ? "Enter Your Name"
                          : "Inserisci Il Tuo Nome"
                      }
                    />
                  </div>

                  <div className='mt-8'>
                    <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  tracking-wider text-xl font-semibold py-2'>
                      E-mail
                    </h2>
                    <input
                      className='bg-[#1E1E1E] dark:bg-[#E3E3E3] py-3 px-5  w-[20rem] md:w-[30rem] text-left text-[#E3E3E3] dark:text-[#1E1E1E]  outline-none rounded-sm focus:outline-[#9499ff]'
                      type='text'
                      name='email'
                      required
                      placeholder={
                        lang === "Eng"
                          ? "Enter Your E-mail"
                          : "Inserisci Il Tuo E-mail"
                      }
                    />
                  </div>

                  <div className='mt-8'>
                    <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  tracking-wider text-xl font-semibold py-2'>
                      {lang === "Eng" ? "Message" : "Messaggio"}
                    </h2>
                    <textarea
                      className='bg-[#1E1E1E] dark:bg-[#E3E3E3] py-5 h-[10rem] px-5  w-[20rem] md:w-[30rem]  text-left text-[#E3E3E3] dark:text-[#1E1E1E]  outline-none rounded-sm focus:outline-[#9499ff]'
                      type='text'
                      name='message'
                      required
                      placeholder={
                        lang === "Eng"
                          ? "Enter Your Message"
                          : "Inserisci Il Tuo Messaggio"
                      }
                    />
                  </div>
                  {result && <Result />}

                  <button type='submit' className='btn mt-6'>
                    {lang === "Eng" ? "Submit" : "Invia"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className='socials pb-4 flex justify-center items-center gap-5'>
          <div>
            <a href='https://github.com/d2ni3l/'>
              <img src={githubicon} className='w-7' alt='' />
            </a>
          </div>
          <div>
            <a href='mailto:lucoo345@gmail.com'>
              {" "}
              <img src={mailicon} className='w-7' alt='' />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

const Result = () => {
  const { lang } = useContext(defaultLang);
  return (
    <div className='mt-3 text-[#9499ff] tracking-wider font-semibold'>
      <p>
        {lang === "Eng"
          ? "Your message was sent successfully!"
          : "Il suo messaggio è stato inviato con successo"}
      </p>
    </div>
  );
};
